module.exports = __webpack_public_path__ + "img/why-choose-us.b9ebce42.png";